import { Grid } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Permissions } from '../../../../../shared/auth/constants/permissions';
import { hasPermission } from '../../../../../shared/auth/permissionHelper';
import { BiddingEntryDataFragment, Permission } from '../../../../api';
import ContentWithLabel from '../../../../components/ContentWithLabel';

export type ViewBiddingEntryProps = {
    entry: BiddingEntryDataFragment;
    index: number;
    permissions: ReadonlyArray<Permission>;
};

const ViewBiddingEntry = ({ entry, index, permissions }: ViewBiddingEntryProps) => {
    const { t } = useTranslation(['saleTransactionsPage']);

    return (
        <Grid spacing={1} container>
            <Grid xs={12} item>
                <h4 style={{ marginTop: 8, marginBottom: 0 }}>
                    {t('saleTransactionsPage:sessionDetails.topBids.index', { index: index + 1 })}
                </h4>
            </Grid>
            <Grid xs={12} item>
                <ContentWithLabel content={entry.id} label={t('saleTransactionsPage:sessionDetails.topBids.entryId')} />
            </Grid>
            <Grid xs={12} item>
                <ContentWithLabel
                    content={entry.dealer.fullName}
                    label={t('saleTransactionsPage:sessionDetails.topBids.dealer')}
                />
            </Grid>
            {hasPermission(permissions, Permissions.OFFER_VIEW_TOP_OFFER_AMOUNTS) && (
                <Grid xs={12} item>
                    <ContentWithLabel
                        content={`${t('common:currency')}${entry.amount?.toLocaleString()}`}
                        label={t('saleTransactionsPage:sessionDetails.topBids.amount')}
                    />
                </Grid>
            )}
            <Grid xs={12} item>
                <ContentWithLabel
                    content={t('common:formats:longDateTime', { date: new Date(entry.placedOn) })}
                    label={t('saleTransactionsPage:sessionDetails.topBids.date')}
                />
            </Grid>
        </Grid>
    );
};

export default ViewBiddingEntry;
